// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header_bar{height:60px!important;background-color:#fff!important;box-shadow:none!important;border-bottom:1px solid #e8ecf4!important}.v-toolbar__content{display:flex;justify-content:space-between;align-items:center}.logo-letter-img{width:30px;flex:none}.logo-word-img{width:139px;flex:none}.header_bar .v-toolbar__content{padding:0 24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
